import StarIcon from "@mui/icons-material/Star"
import StarHalfIcon from "@mui/icons-material/StarHalf"
import StarBorderIcon from "@mui/icons-material/StarBorder"

const RatingStars = ({ value = 4.5, max = 5 }) => {
  const fullStars = Math.floor(value)
  const hasHalfStar = value % 1 >= 0.5
  const emptyStars = max - fullStars - (hasHalfStar ? 1 : 0)

  return (
    <div style={{ display: "flex", gap: "5px" }}>
      {/* Full stars */}
      {[...Array(fullStars)].map((_, i) => (
        <StarIcon key={`full-${i}`} style={{ color: "#FFB400" }} fontSize="medium" />
      ))}

      {/* Half star */}
      {hasHalfStar && (
        <StarHalfIcon style={{ color: "#FFB400" }} fontSize="medium" />
      )}

      {/* Empty stars (optional) */}
      {[...Array(emptyStars)].map((_, i) => (
        <StarBorderIcon key={`empty-${i}`} style={{ color: "#FFB400" }} fontSize="medium" />
      ))}
    </div>
  )
}

export default RatingStars;